import css from 'styled-jsx/css';
import { colors } from '../../../../../../config/styles';

export const ProductQuantitySelectionContainerStyle = css`
  /* Block: Main product quantity selection container */
  .product-quantity-selection {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  /* Element: Main horizontal row container */
  .product-quantity-selection__main-row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  /* Element: Calculator section */
  .product-quantity-selection__calculator {
    flex-shrink: 0;
    min-width: auto;
  }

  /* Element: Add to cart section */
  .product-quantity-selection__add-to-cart {
    flex: 1;
    display: flex;
    align-items: center;
    transition: opacity 0.2s ease-in-out;
    min-width: 0; /* Allow flex shrinking */
  }

  /* Modifier: Loading state for add to cart section */
  .product-quantity-selection__add-to-cart--loading {
    opacity: 0.7;
    pointer-events: none;
  }

  /* Element: Button container */
  .product-quantity-selection__button-container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  /* Override AddToCartButton internal styles */
  .product-quantity-selection__button-container :global(.add-quantity-container) {
    margin: 0 !important;
    flex-shrink: 0;
  }

  /* Make buttonForCustomers container expand */
  .product-quantity-selection__button-container :global(#buttonForCustomers) {
    flex: 1 !important;
    width: 100% !important;
  }

  /* Override AddToCartButton internal styles */
  .product-quantity-selection__button-container :global(.button-mkp-primary-xtra-large-outlined) {
    background-color: ${colors.gray.shade64};
    color: ${colors.white.shade1};
  }

  /* Override AddToCartButton internal styles */
  .product-quantity-selection__button-container :global(.button-mkp-primary-xtra-large) {
    width: 100% !important;
    min-width: 200px !important;
    height: 40px !important;
  }

  /* Element: Favorites section placeholder */
  .product-quantity-selection__favorites {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    border-radius: 25px;
    background-color: ${colors.white.shade4};
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }

  .product-quantity-selection__favorites:hover {
    border-color: #cccccc;
    background-color: #f9f9f9;
  }

  /* Element: Error message container */
  .product-quantity-selection__error {
    margin-top: 8px;
    animation: slideIn 0.3s ease-out;
  }

  /* Animations */
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .product-quantity-selection {
      gap: 10px;
    }

    .product-quantity-selection__main-row {
      gap: 10px;
    }

    .product-quantity-selection__favorites {
      width: 40px;
      height: 40px;
    }

    .product-quantity-selection__error {
      margin-top: 6px;
    }
  }

  @media (max-width: 480px) {
    .product-quantity-selection {
      gap: 8px;
    }

    .product-quantity-selection__main-row {
      gap: 8px;
      flex-direction: column;
      align-items: center;
    }

    .product-quantity-selection__calculator,
    .product-quantity-selection__add-to-cart {
      width: 100%;
    }

    .product-quantity-selection__favorites {
      align-self: center;
      width: 36px;
      height: 36px;
    }
  }

  /* High contrast support */
  @media (prefers-contrast: high) {
    .product-quantity-selection__add-to-cart--loading {
      opacity: 0.5;
      border: 2px solid currentColor;
    }

    .product-quantity-selection__favorites {
      border: 2px solid currentColor;
    }
  }

  /* Reduced motion support */
  @media (prefers-reduced-motion: reduce) {
    .product-quantity-selection__add-to-cart {
      transition: none;
    }

    .product-quantity-selection__error {
      animation: none;
    }
  }
`;
